import axios from "@lib/axios";

export async function getAddresses() {
  const res = await axios.get("addresses");
  return res.data.data;
}

export async function getAddress(id) {
  const res = await axios.get(`addresses/${id}`);
  return res.data.data;
}

export async function postAddress(data) {
  const res = await axios.post("addresses", { address: data });
  return res.data.data;
}

export async function putAddress(id, data) {
  const res = await axios.put(`addresses/${id}`, { address: data });
  return res.data.data;
}

export async function updateAddressType(id, data) {
  const res = await axios.put(`users/address_types/${id}`, { address_type: data });
  return res.data.data;
}

export async function deleteAddress(id) {
  const res = await axios.delete(`addresses/${id}`);
  return res.data.data;
}

export async function updateReturnCarrier(carrierName) {
  const res = await axios.put("users/return_carriers", { carrier_name: carrierName });
  return res.data.data;
}
